
  <quill-editor
    [formControl]="formControl"
    [modules]="quillModules"
    [theme]="'snow'"
    [readOnly]="to.disabled"
  >
  </quill-editor>
  


// WEBPACK FOOTER //
// ./src/app/shared/components/schema-form/formly-field-quill/formly-field-quill.component.ts.FormlyFieldQuillComponent.html